import { formatNumberToParts } from '@niaratech/niara-js-commons';
const formatPointsToParts = (value: number, locale?: string, fractionDigits?: number): ReturnType<typeof formatNumberToParts> => {
  const fractionDigitsToUse = fractionDigits ?? Math.round(value * 100) % 100 != 0 ? 2 : 0;
  return formatNumberToParts(value, locale, fractionDigitsToUse);
};
export default formatPointsToParts;